var map = {
	"./approve.png": 99243,
	"./business.png": 51708,
	"./channel.png": 79725,
	"./dataScreen.png": 13654,
	"./logo.png": 42839,
	"./report.png": 56788,
	"./setting.png": 37544,
	"./user-2.png": 9742,
	"./user-3.png": 9239,
	"./userBusiness.png": 76557,
	"./userScreen.png": 75951
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5105;